import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../actions'
import {
  Collapse,
  Button,
  Card
} from 'react-bootstrap'
import {
  renderTextField
} from '../../../../Forms/fieldRenderers'

import { Field, reduxForm } from 'redux-form'
import { FORM_INGRESO_COMPLETO } from '../../../../../config/forms'

class ValidacionExterna extends Component {
  componentDidMount () {
    const {
      currentCpa,
      change: formChange
    } = this.props
    formChange('validacionExterna', currentCpa && currentCpa.validacionCtg)
  }

  render () {
    const {
      iCompletoValidacionExterna,
      currentCpa,
      toogleValidacion
    } = this.props

    const label = iCompletoValidacionExterna
      ? 'Desactivar validación externa'
      : (currentCpa && currentCpa.validacionCtg)
        ? 'Modificar validación externa'
        : 'Activar validación externa'

    return (
      <div>
        <Button
          onClick={() => toogleValidacion()}
          size='lg'
        >{label}</Button>
        <br />
        {/* <Card onToggle={() => null} expanded={iCompletoValidacionExterna}>
          <Card.Body> */}
        <Collapse in={iCompletoValidacionExterna}>
          <Card>
            <Card.Body>
              <Field className='validacionExt'
                name='validacionExterna'
                type='text'
                label='Codigo cancelación'
                component={renderTextField}
                autoFocus
              />
            </Card.Body>
          </Card>
        </Collapse>
        {/* </Card.Body>
        </Card> */}
      </div>
    )
  };
};

const mapStateToProps = (state) => ({
  currentCpa: state.camionesIngreso.iCompletoCpa,
  iCompletoValidacionExterna: state.camionesIngreso.iCompletoValidacionExterna
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_INGRESO_COMPLETO,
  enableReinitialize: false,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false
})

export default withRedux(withReduxForm(ValidacionExterna))
